<!-- eslint-disable prettier/prettier -->
<template>
    <fragment name="payout-logs-page-container">
        <div class="row">
            <div class="column small-12 medium-3">
              <profile-strength
                :percentage="models.profileStrength.percentage"
                class="mbm"
              />
              <manage-account-menu :menu="models.menu" />
            </div>
            <div class="column small-12 medium-9">
                <PayoutMethodTable
                  :payout-methods="currentPage"
                  :api-base-url="pagination.apiBaseUrl"
                  :delete-icon="icons.deleteIcon"
                  :paypal-icon="icons.paypalIcon"
                  :payoneer-icon="icons.payoneerIcon"
                  :skrill-icon="icons.skrillIcon"
                  @table-update="onTableUpdate"
                />
                <Pagination
                  class="mtm"
                  :max-page="pagination.maxPage"
                  :current="pagination.current"
                  :start="pagination.start"
                  :end="pagination.end"
                  :start-of-page="pagination.startOfPage"
                  :number-of-results="pagination.numberOfResults"
                  :total-results-count="pagination.totalResultsCount"
                  :description="pagination.description"
                  :base-url="pagination.baseUrl"
                  :api-base-url="pagination.apiBaseUrl"
                  :left-arrow-icon-url="icons.paginationLeftArrow"
                  :right-arrow-icon-url="icons.paginationRightArrow"
                  :api-post-object="apiPostObject"
                  @page-link-click="onPaginationClick"
                />
            </div>
        </div>
    </fragment>
  </template>

<script>
import PayoutMethodTable from '../../components/my-account/designer/payout-method/PayoutMethodTable.vue';
import ManageAccountMenu from '../../components/my-account/ManageAccountMenu/ManageAccountMenu.vue';
import ProfileStrength from '../../components/my-account/designer/overview/ProfileStrength/ProfileStrength.vue';
import Pagination from '../../components/shared/PaginationV2/PaginationV2.vue';

export default {
  components: {
    PayoutMethodTable,
    ManageAccountMenu,
    ProfileStrength,
    Pagination,
  },
  props: {
    models: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      apiPostObject: {},
      currentPage: this.models.payoutMethods,
      pagination: this.models.pagination,
    };
  },
  methods: {
    onPaginationClick(e) {
      this.currentPage = e.items;
      this.pagination = e.pagination;
    },
    onTableUpdate(e) {
      this.currentPage = e.resData.items;
      this.pagination = e.resData.pagination;
    },
  },
};
</script>